/**
 * Danh mục trường hợp quyết toán
 * NHANH3 29.03.2024
 */
export default {
  Periodic: 1,
  Reorganization: 2,
  ConvertType: 3,
  ConvertFiscalPeriod: 4,
  Dissolution: 5,
  Terminate: 6,
};
